import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, BasicForms } from "../../../components";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import Panel from "../../../components/panel/Panel";
import cx from "classnames";
import { Button, Checkbox } from "react-bootstrap";
import NumberFormat from "react-number-format";
import isEmpty from "lodash.isempty";
import { Tooltip } from "react-bootstrap";

class StepThree extends Component {
  static propTypes = {
    getCityGeolocation: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      loccountry: "",
      locstate: "",
      loccity: "",
      loccityId: "",
      locaddress1: "",
      locaddress2: "",
      loclatitude: "",
      loclongitude: "",
      locphone: "",
      //islocbasic: "0",
      locstatesName: [],
      loccitiesData: [],
      loccountryData: [],
      locstateAbbr: "",
      loccountryName: "",
      countryerror: "",
      stateerror: "",
      cityerror: "",
      market: "",
      bycityError: "",
      loclongitudeMsg: "",
      loclatitudeMsg: "",
      hostname: "",
      db_name: "",
      db_user: "",
      db_password: "",
      ProposalType:[1, 2, 3, 4, 5, 6, 7, 8],
    };

    this.validate = this.validate.bind(this);
    this.handlesOnChanged = this.handlesOnChanged.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handlesOnLocPhoneChanged = this.handlesOnLocPhoneChanged.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  validate = () => {
    let isError = false;
    const errors = {};
    const mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
    let phonenumber = this.state.locphone;
    if (!this.state.loclatitude) {
      isError = true;
      this.setState({
        loclatitudeError: "red"
      });
    }
    if (this.state.loclatitude) {
      if (this.state.loclatitudeMsg !== "") {
        isError = true;
        this.setState({
          loclatitudeError: "red"
        });
      }
    }
    if (!this.state.loclongitude) {
      isError = true;
      this.setState({ loclongitudeError: "red" });
    }
    if (this.state.loclongitude) {
      if (this.state.loclongitudeMsg !== "") {
        isError = true;
        this.setState({
          loclongitudeError: "red"
        });
      }
    }
    if (!this.state.locaddress1) {
      isError = true;
      this.setState({
        locaddress1Error: "red"
      });
    }
    if (!this.state.market) {
      isError = true;
      this.setState({
        marketError: "Please select location either by city or geolocation!"
      });
    } else {
      this.setState({ marketError: "" });
    }

    if (this.state.loccountry && this.state.loccountry.length === 0) {
      isError = true;
      this.setState({ countryerror: "true" });
    }

    if (this.state.locstate && this.state.locstate.length === 0) {
      isError = true;
      this.setState({ stateerror: "true" });
    }
    if (this.state.loccity && this.state.loccity.length === 0) {
      isError = true;
      this.setState({ cityerror: "true" });
    }

    if (!this.state.hostname) {
      isError = true;
      this.setState({ hostnameError: "red" });
    }else {
      this.setState({ hostnameError: "" });
    }

    if (!this.state.db_name) {
      isError = true;
      this.setState({ db_nameError: "red" });
    }else {
      this.setState({ db_nameError: "" });
    }

    if (!this.state.db_user) {
      isError = true;
      this.setState({ db_userError: "red" });
    }else {
      this.setState({ db_userError: "" });
    }

    if (!this.state.db_password) {
      isError = true;
      this.setState({ db_passwordError: "red" });
    }else {
      this.setState({ db_passwordError: "" });
    }

    return isError;
  };

  handlesOnLocPhoneChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ locphone: e.target.value });
  }

  handlesOnChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCheckbox(e) {
    let ProposalArr = [...this.state.ProposalType];
    let val = parseInt(e.target.value);
    let indx = ProposalArr.indexOf(val);
    if(e.target.checked) {
      if(indx === -1) {
        ProposalArr.push(val);
        ProposalArr.sort((a, b) => (a-b));
        this.setState({ProposalType:ProposalArr});
      }
    } else { 
      if(indx !== -1) {
        ProposalArr.splice(indx, 1);
        ProposalArr.sort((a, b) => (a-b));
        this.setState({ProposalType:ProposalArr});
      }
    }
  }

  handleChange(event) {
    this.setState({
      market: event.target.value
    });
    if (event.target.value == "City") {
      if (this.state.loccityId == null) {
        this.setState({ bycityError: "Please select a city!" });
      }
    } else {
      this.setState({ bycityError: "" });
    }
    this.setState({ marketError: "" });
  }

  onSelectedCountry = (val, key) => {
    this.setState({ loccountry: val });
    this.setState({ loccountryName: key });
    if (!this.state.loccountry) {
      this.setState({ loccountryError: "" });
    }
  };

  onSelectedState = (val, key) => {
    this.setState({ locstate: key });
    this.setState({ locstateAbbr: val });
    if (!this.state.locstate) {
      this.setState({ locstateError: "" });
    }
  };

  onSelectedCity = (val, key) => {
    this.setState({ loccity: val });
    this.setState({ loccityId: key });
    if (!this.state.loccity) {
      this.setState({ loccityError: "" });
    }
    if (key !== "") {
      this.props.getCityGeolocation(key);
      this.setState({ bycityError: "" });
    }
  };

  handleBlur(e) {
    if (e.target.value.length > 0) {
      if (e.target.name === "loclatitude") {
        if (
          !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
            e.target.value
          )
        ) {
          this.setState({ loclatitudeMsg: "Invalid Latitude" });
        } else {
          this.setState({ loclatitudeMsg: "" });
        }
      } else if (e.target.name === "loclongitude") {
        if (
          !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
            e.target.value
          )
        ) {
          this.setState({ loclongitudeMsg: "Invalid Longitude" });
        } else {
          this.setState({ loclongitudeMsg: "" });
        }
      }
    }
  }

  previousStep(e) {
    e.preventDefault();
    let fieldValues = this.props.saveValues();
    this.props.previousStep();
  }

  componentWillMount() {
    const rehydrate = JSON.parse(localStorage.getItem("addNewSiteSavedState"));
    this.setState(rehydrate);
    if (this.props.siteDetails.siteID) {
      this.setState({
        loccountryName: this.props.siteDetails.locCountryName,
        loccountry: this.props.siteDetails.locCountry,
        locstate: this.props.siteDetails.locStateName,
        locstateAbbr: this.props.siteDetails.locState,
        loccity: this.props.siteDetails.locCity,
        loccityId: this.props.siteDetails.locCityID,
        locphone: this.props.siteDetails.locPhone,
        locaddress1: this.props.siteDetails.locAddress1,
        locaddress2: this.props.siteDetails.locAddress2,
        loclatitude: this.props.siteDetails.locLatitude,
        loclongitude: this.props.siteDetails.locLongitude,
        //islocbasic: this.props.siteDetails.isLocationBasic,
        market: this.props.siteDetails.siteDealMethod,
        hostname: this.props.siteDetails.hostname,
        db_user: this.props.siteDetails.db_user,
        db_name: this.props.siteDetails.db_name,
        db_password: this.props.siteDetails.db_password,
        ProposalType: this.props.siteDetails.proposaltype,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.citygeolocation !== nextProps.citygeolocation &&
      !isEmpty(nextProps.citygeolocation)
    ) {
      this.setState({
        loclatitude: nextProps.citygeolocation.data.latitude,
        loclongitude: nextProps.citygeolocation.data.longitude
      });
      this.setState({
        loclongitudeMsg: "",
        loclatitudeMsg: "",
        loclatitudeError: "",
        loclongitudeError: ""
      });
    }
  }

  componentWillUnmount() {
    localStorage.setItem("addNewSiteSavedState", JSON.stringify(this.state));
  }

  nextStep(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      var data = {
        locCountry: this.state.loccountry,
        locCountryName: this.state.loccountryName,
        locState: this.state.locstateAbbr,
        locStateName: this.state.locstate,
        locCity: this.state.loccity,
        loccityID: this.state.loccityId,
        locAddress1: this.state.locaddress1.trim(),
        locAddress2: this.state.locaddress2,
        locLatitude: this.state.loclatitude,
        locLongitude: this.state.loclongitude,
        locPhone: this.state.locphone,
        //isLocationBasic: this.state.islocbasic,
        siteDealMethod: this.state.market,
        hostname: this.state.hostname,
        db_name: this.state.db_name,
        db_user: this.state.db_user,
        db_password: this.state.db_password,
        ProposalType: this.state.ProposalType,
      };
      this.props.saveValues(data);
      this.props.nextStep();
    }
  }

  render() {
    const previous = "Previous";
    const next = "Next";
    const headerTitle = "Company Address";
    return (
      <div>
        <Panel hasTitle={true} title={headerTitle}>
          <form role="form" id="StepThree">
            <div className="col-md-6">
              <div className="form-group">
                <CountryStateCity
                  onSelectedCountry={this.onSelectedCountry}
                  onSelectedState={this.onSelectedState}
                  onSelectedCity={this.onSelectedCity}
                  country={this.state.loccountry}
                  countryName={this.state.loccountryName}
                  state={this.state.locstate}
                  stateAbbr={this.state.locstateAbbr}
                  city={this.state.loccity}
                  cityId={this.state.loccityId}
                  countryerror={this.state.countryerror}
                  stateerror={this.state.stateerror}
                  cityerror={this.state.cityerror}
                  required="required"
                />
              </div>

              <div className="form-group">
                <label htmlFor="locphone">Phone (format: xxx-xxx-xxxx)</label>

                <NumberFormat
                  format="###-###-####"
                  mask="_"
                  className="form-control"
                  name="locphone"
                  placeholder="Location Number"
                  value={this.state.locphone}
                  onChange={this.handlesOnLocPhoneChanged}
                />
              </div>

              <div className="form-group">
                <label htmlFor="hostname">
                  Host Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="hostname"
                  placeholder="Host Name"
                  onChange={this.handlesOnChanged}
                  value={this.state.hostname}
                  style={{ borderColor: this.state.hostnameError }}
                  onBlur={this.handleBlur}
                />
                {this.state.hostnameMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.hostnameMsg}
                  </Tooltip>
                )}
              </div>
              

              <div className="form-group">
                <label htmlFor="db_name">
                  Database Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="db_name"
                  placeholder="Database Name"
                  onChange={this.handlesOnChanged}
                  value={this.state.db_name}
                  style={{ borderColor: this.state.db_nameError }}
                  onBlur={this.handleBlur}
                />
                {this.state.db_nameMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.db_nameMsg}
                  </Tooltip>
                )}
              </div>
              
              <div className="form-group">
                <label htmlFor="loclongitude">Select Location</label>
                <br />
                <label>
                  <input
                    type="radio"
                    value="City"
                    checked={this.state.market === "City"}
                    onChange={this.handleChange.bind(this)}
                  />
                  By city
                </label>
                {this.state.bycityError && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.bycityError}
                  </Tooltip>
                )}
                <label>
                  <input
                    type="radio"
                    value="LatLong"
                    checked={this.state.market === "LatLong"}
                    onChange={this.handleChange.bind(this)}
                  />
                  By geolocation
                </label>
              </div>
              {this.state.marketError && (
                <Tooltip placement="bottom" className="in" id="tooltip-bottom">
                  {this.state.marketError}
                </Tooltip>
              )}
              {/* <div className="form-group">
                <label htmlFor="islocbasic">Is Location Basic</label>
                <select
                  name="islocbasic"
                  className="form-control"
                  style={{ borderColor: this.state.locisbasicError }}
                  value={this.state.islocbasic}
                  onChange={this.handlesOnChanged}
                >
                  <option value="0">Yes</option>
                  <option value="1">No</option>
                </select>
              </div> */}
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="locaddress1">Address1</label>

                <input
                  type="text"
                  className="form-control"
                  name="locaddress1"
                  placeholder="Location Address1"
                  onChange={this.handlesOnChanged}
                  value={this.state.locaddress1}
                  style={{ borderColor: this.state.locaddress1Error }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="locaddress2">Address2</label>

                <input
                  type="text"
                  className="form-control"
                  name="locaddress2"
                  placeholder="Location Address2"
                  onChange={this.handlesOnChanged}
                  value={this.state.locaddress2}
                  style={{ borderColor: this.state.locaddress2Error }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="loclatitude">
                  Latitude(format: 0.0 Or -0.0)
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="loclatitude"
                  placeholder="Location Latitude"
                  onChange={this.handlesOnChanged}
                  value={this.state.loclatitude}
                  style={{ borderColor: this.state.loclatitudeError }}
                  onBlur={this.handleBlur}
                />
                {this.state.loclatitudeMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.loclatitudeMsg}
                  </Tooltip>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="loclongitude">
                  Longitude(format: 0.0 Or -0.0)
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="loclongitude"
                  placeholder="Location Longitude"
                  onChange={this.handlesOnChanged}
                  value={this.state.loclongitude}
                  style={{ borderColor: this.state.loclongitudeError }}
                  onBlur={this.handleBlur}
                />
                {this.state.loclongitudeMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.loclongitudeMsg}
                  </Tooltip>
                )}
              </div>
              
              <div className="form-group">
                <label htmlFor="db_user">
                  Database User Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="db_user"
                  placeholder="DB User Name"
                  onChange={this.handlesOnChanged}
                  value={this.state.db_user}
                  style={{ borderColor: this.state.db_userError }}
                  onBlur={this.handleBlur}
                />
                {this.state.db_userMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.db_userMsg}
                  </Tooltip>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="db_password">
                  Database Password
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="db_password"
                  placeholder="Database Password"
                  onChange={this.handlesOnChanged}
                  value={this.state.db_password}
                  style={{ borderColor: this.state.db_passwordError }}
                  onBlur={this.handleBlur}
                />
                {this.state.db_passwordMsg && (
                  <Tooltip
                    placement="bottom"
                    className="in"
                    id="tooltip-bottom"
                  >
                    {this.state.db_passwordMsg}
                  </Tooltip>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Active Contract/Proposal Type</label>
                <Checkbox value="1" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(1) !== -1) ? true : false)}>Standard Merchant</Checkbox>
                <Checkbox value="2" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(2) !== -1) ? true : false)} >Premium Merchant</Checkbox>
                <Checkbox value="3" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(3) !== -1) ? true : false)}>Products</Checkbox>
                <Checkbox value="4" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(4) !== -1) ? true : false)}>Travel</Checkbox>
                <Checkbox value="5" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(5) !== -1) ? true : false)}>Events</Checkbox>
                <Checkbox value="6" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(6) !== -1) ? true : false)}>Coupon Offer</Checkbox>
                <Checkbox value="7" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(7) !== -1) ? true : false)}>Affiliate Offer</Checkbox>
                <Checkbox value="8" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(8) !== -1) ? true : false)}>Gift Card Vouchers</Checkbox>
                <Checkbox value="9" onChange={this.handleCheckbox} defaultChecked={((this.state.ProposalType.indexOf(9) !== -1) ? true : false)}>Recurring Billing</Checkbox>
              </div>
            </div>

            <div className="form-footer col-md-12">
              <Button
                bsStyle="success"
                className="btn -default pull-left"
                onClick={this.previousStep}
              >
                Back
              </Button>
              <Button
                bsStyle="info"
                className="btn -primary pull-right"
                onClick={this.nextStep}
              >
                Next
              </Button>
            </div>
          </form>
        </Panel>
      </div>
    );
  }
}

export default StepThree;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/steps/StepThree.js